const locale = require('./collaborationNote.i18n.json');

/*@ngInject*/
const CollaborationNoteController = function ($scope, $rootScope, collaborationMediator, authorizationConstants, currentUserModel) {

    $scope.i18n = locale;

    function resetNoteViewModel() {
        $scope.noteViewModel = {
            note: null,
            editPermission: null,
            editOtherUsersPermission: null,
            deletePermission: null,
            sharePermission: null,
            editMode: false
        };
    }

    function loadCollaborationNote(noteId) {
        resetNoteViewModel();

        $scope.viewModel.isLoading = true;
        let permissions = [],

            handleSuccess = function (noteItem) {
            $scope.viewModel.isLoading = false;

            $scope.noteViewModel.note = noteItem.Note;
            $scope.noteViewModel.isCreateNote = _.isNil(noteItem.Note.id);
            $scope.viewModel.note.isVisible = true;

            let neededPermissions = [
                authorizationConstants.AUTHORIZATION_ADD_MODIFY_NOTES,
                authorizationConstants.AUTHORIZATION_DELETE_NOTES,
                authorizationConstants.AUTHORIZATION_SHARE_UNSHARE_NOTES,
                authorizationConstants.AUTHORIZATION_MODIFY_OTHER_USERS_NOTE_OPTIONS
            ];

            _.each(neededPermissions, function (neededPermission) {
                if (currentUserModel.hasAuthorization(neededPermission)) {
                    permissions.push(neededPermission);
                }
            });

            $scope.noteViewModel.editPermission = (_.includes(permissions, authorizationConstants.AUTHORIZATION_ADD_MODIFY_NOTES));
            $scope.noteViewModel.editOtherUsersPermission = (_.includes(permissions, authorizationConstants.AUTHORIZATION_MODIFY_OTHER_USERS_NOTE_OPTIONS));
            $scope.noteViewModel.deletePermission = (_.includes(permissions, authorizationConstants.AUTHORIZATION_DELETE_NOTES));
            $scope.noteViewModel.sharePermission = (_.includes(permissions, authorizationConstants.AUTHORIZATION_SHARE_UNSHARE_NOTES));
        };

        if (noteId) {
            collaborationMediator.loadCollaborationNote(noteId).then(handleSuccess);
        } else {
            $scope.viewModel.isLoading = false;
            // creating a new note
            let noteItem = {};

            noteItem[authorizationConstants.AUTHORIZATION_ADD_MODIFY_NOTES] = true;
            noteItem[authorizationConstants.AUTHORIZATION_DELETE_NOTES] = true;
            noteItem[authorizationConstants.AUTHORIZATION_SHARE_UNSHARE_NOTES] = false;

            noteItem.Note = {
                authorId: $scope.viewModel.currentUserId
            };

            handleSuccess(noteItem);
        }
    }

    $scope.isCurrentUser = function () {
        if ($scope.noteViewModel && _.isPlainObject($scope.noteViewModel.note)) {
            if ($scope.viewModel.currentUserId === $scope.noteViewModel.note.authorId) {
                return true;
            }
        }
        return false;
    };

    $scope.$watch('viewModel.selectedItem', function (newItem) {
        if (newItem && newItem.type === 'note') {
            loadCollaborationNote(newItem.id);
        } else {
            // empty the current form
            $scope.noteViewModel.note = {};
        }
    });

    $scope.canEdit = function () {
        return $scope.noteViewModel.editPermission;
    };

    $scope.canDelete = function () {
        return $scope.noteViewModel.deletePermission;
    };

    $scope.canEditShare = function () {
        return $scope.noteViewModel.sharePermission;
    };

    $scope.canModify = function (){
        return $scope.isCurrentUser() && $scope.noteViewModel.editPermission;
    };

    $scope.canModifyOtherUserOptions = function (){
        return !$scope.isCurrentUser() && $scope.noteViewModel.editOtherUsersPermission;
    };

    $scope.getDisplayedTime = function () {
        let roundedTimeCreated, roundedLastModified;

        if ($scope.noteViewModel.note) {
            if ($scope.noteViewModel.note && $scope.noteViewModel.note.timeCreated && $scope.noteViewModel.note.lastModified) {
                return $scope.noteViewModel.note.lastModified;
            }

            return $scope.noteViewModel.note.timeCreated;
        }
    };

    $scope.isMultipleDateDisplayed = function () {
        let roundedTimeCreated, roundedLastModified,
            coeff = 1000 * 60 * 5;

        if ($scope.noteViewModel.note && $scope.noteViewModel.note.timeCreated && $scope.noteViewModel.note.lastModified) {
            roundedTimeCreated = new Date(Math.round($scope.noteViewModel.note.timeCreated.getTime() / coeff) * coeff);
            roundedLastModified = new Date(Math.round($scope.noteViewModel.note.lastModified.getTime() / coeff) * coeff);
        } else {
            return false;
        }

        return ($scope.noteViewModel.note &&
            $scope.noteViewModel.note.lastModified &&
            roundedTimeCreated !== roundedLastModified);
    };

    $scope.getTitle = function () {
        if (!$scope.noteViewModel || !_.isPlainObject($scope.noteViewModel.note)) {
            return '';
        }
        if ($scope.noteViewModel.note.id) {
            return $scope.i18n.title;
        } else {
            return $scope.i18n.newTitle;
        }
    };

    resetNoteViewModel();
};

angular.module('gw-um-submission')
    .controller('collaborationNoteController', CollaborationNoteController);
